export default __webpack_public_path__ + "static/media/A Cruel Angel s Thesis (Director s Edit Version) - Shiro Sag.9bdf8398.m4a";